<template>
  <router-view></router-view>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      show: false
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
